import { ShaftByShaftNameForDropdown } from '@/api/models';

export interface IShaftOptionMap {
  map: Record<string, ShaftByShaftNameForDropdown>;
  options: Array<{
    id: string;
    label: string;
  }>;
  groups: Record<
    string,
    Array<{
      id: string;
      label: string;
      manufacturer: string;
      number?: number; // serializtion number (#5, #6, etc.)
      shaftPinstamp: string;
    }>
  >;
}

// Match shaft names with a serialization id - ie Steelfiber F4 #1
const serializationRegex = /^(.*)\s#(\d+)$/;

// Create shaft groups by base model and series
// Steelfiber F4
//   - #1, #2, #3 etc
const assignToGroup = (shaft: ShaftByShaftNameForDropdown, label: string, groups: IShaftOptionMap['groups']) => {
  const match = shaft.name.match(serializationRegex);
  const manufacturer = shaft.shaftManufacturerName;
  const shaftPinstamp = shaft.shaftPinstamp;

  if (match) {
    // serialized iron shaft
    const baseName = match[1].trim();
    const number = parseInt(match[2], 10);

    if (!groups[baseName]) groups[baseName] = [];
    groups[baseName].push({ id: String(shaft.id), label, manufacturer, number, shaftPinstamp });
  } else {
    // non-serialized utility shaft
    const baseName = label.trim();
    if (!groups[baseName]) groups[baseName] = [];
    groups[baseName].push({ id: String(shaft.id), label, manufacturer, shaftPinstamp });
  }
};

export const buildShaftDropdown = (shafts: ShaftByShaftNameForDropdown[]): IShaftOptionMap => {
  const map: Record<string, ShaftByShaftNameForDropdown> = {};
  const options: { id: string; label: string }[] = [];
  const groups: IShaftOptionMap['groups'] = {};

  shafts.forEach((shaft) => {
    const id = String(shaft.id);
    const label = `${shaft.shaftManufacturerName} ${shaft.name}`;

    map[id] = shaft;
    options.push({ id, label });

    assignToGroup(shaft, shaft.name, groups);
  });

  // sort each group once after building
  Object.values(groups).forEach((group) => {
    group.sort((a, b) => {
      if (a.number !== undefined && b.number !== undefined) {
        return a.number - b.number;
      }
      return (a.label ?? '').localeCompare(b.label ?? '');
    });
  });

  return { map, options, groups };
};
